var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGuideNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 128,
    viewBox: "0 0 139 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 40392"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M90.3705 41.8026L104.717 17.0779C104.717 17.0779 94.2164 15.7306 80.1287 18.9505C65.1873 22.3652 58.5418 24.4567 51.2735 18.7305C44.384 13.3031 29.6144 -1.22018 8.87461 0.0822129C7.71012 0.155541 7.29642 1.66479 8.25187 2.33568C12.7873 5.52162 20.6914 12.0347 16.5806 16.3074C13.364 19.6509 6.49856 23.2462 1.21895 25.7087C-0.00355381 26.2789 0.432037 28.1088 1.7804 28.0738C7.4781 27.925 15.2771 28.5247 21.0963 32.0565C32.1645 38.7742 37.86 44.925 50.3925 45.6879C63.0575 46.4584 67.2831 42.6891 76.7545 41.9186C86.2258 41.1481 90.3716 41.8037 90.3716 41.8037L90.3705 41.8026Z",
    fill: "#5E42E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M55.3744 37.7398C57.7154 33.3215 60.1549 28.959 62.6929 24.6512C63.1252 23.9169 61.9837 23.2514 61.5514 23.9836C59.0123 28.2914 56.5728 32.6539 54.2328 37.0732C53.8345 37.824 54.9749 38.4927 55.3744 37.7398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M48.4926 40.7879C49.7151 38.2412 50.9923 35.725 52.3877 33.2669C52.808 32.5259 51.6665 31.8594 51.2462 32.6004C49.8508 35.0574 48.5735 37.5735 47.3511 40.1214C46.9844 40.8843 48.1237 41.5562 48.4926 40.7879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M50.2151 124.249C58.759 124.249 65.6852 117.322 65.6852 108.779C65.6852 100.235 58.759 93.3086 50.2151 93.3086C41.6713 93.3086 34.7451 100.235 34.7451 108.779C34.7451 117.322 41.6713 124.249 50.2151 124.249Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M22.7676 87.3951C31.3115 87.3951 38.2377 80.469 38.2377 71.9251C38.2377 63.3812 31.3115 56.4551 22.7676 56.4551C14.2238 56.4551 7.29761 63.3812 7.29761 71.9251C7.29761 80.469 14.2238 87.3951 22.7676 87.3951Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M52.101 95.4408L104.715 5.1543C104.715 5.1543 82.5967 9.66999 70.4746 36.8298C58.3525 63.9907 46.0071 95.2591 46.0071 95.2591L52.0999 95.4408H52.101Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M36.3596 66.6021L138.5 40.2324C138.5 40.2324 128.148 60.2948 98.7169 64.585C69.285 68.8763 37.2855 70.4359 37.2855 70.4359L36.3596 66.601V66.6021Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M67.6827 63.2617C67.6827 64.8837 66.3683 66.1981 64.7452 66.1981C63.1222 66.1981 61.8088 64.8837 61.8088 63.2617C61.8088 61.6397 63.1233 60.3242 64.7452 60.3242C66.3672 60.3242 67.6827 61.6387 67.6827 63.2617Z",
    fill: "#FFE7D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M103.073 34.4799L131.415 25.9629C131.415 25.9629 133.46 34.7633 133.47 44.6123C133.491 63.2617 130.386 69.4289 121.538 84.1503C113.181 98.0553 119.163 113.893 125.372 124.951C126.283 126.573 124.347 128.295 122.846 127.195C115.892 122.1 105.94 115.391 101.751 115.391C97.5611 115.391 96.2828 121.22 95.9512 125.57C95.8286 127.18 93.7842 127.781 92.8298 126.479C89.5935 122.064 84.9651 114.29 85.1566 106.141C85.4499 93.6589 94.0917 85.827 99.2542 77.3593C104.716 68.4012 107.119 54.9242 103.073 34.4799Z",
    fill: "#5E42E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M103.132 86.8905C107.254 86.9069 111.375 86.9222 115.497 86.9386C116.347 86.9419 116.348 85.6198 115.497 85.6165C111.375 85.6001 107.254 85.5848 103.132 85.5684C102.281 85.5651 102.28 86.8861 103.132 86.8905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M95.6546 90.9683C98.5953 90.919 101.537 90.9026 104.478 90.803C105.326 90.7746 105.331 89.4525 104.478 89.4809C101.538 89.5805 98.5964 89.5969 95.6546 89.6462C94.8053 89.6604 94.802 90.9825 95.6546 90.9683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M22.5127 81.9482C28.4387 81.9482 33.2427 77.1443 33.2427 71.2183C33.2427 65.2923 28.4387 60.4883 22.5127 60.4883C16.5867 60.4883 11.7827 65.2923 11.7827 71.2183C11.7827 77.1443 16.5867 81.9482 22.5127 81.9482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M50.3445 119.505C56.2705 119.505 61.0744 114.701 61.0744 108.775C61.0744 102.849 56.2705 98.0449 50.3445 98.0449C44.4185 98.0449 39.6145 102.849 39.6145 108.775C39.6145 114.701 44.4185 119.505 50.3445 119.505Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGuideNew);
export default __webpack_public_path__ + "static/media/ic_guide_new.fbec57fa8e8a6bd49afbcf6806e5af29.svg";
export { ForwardRef as ReactComponent };